class MobileMenu extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector("[data-mobile-menu-toggle]");
    this.closeButton = this.querySelector("[data-mobile-menu-close]");
    this.toggle.addEventListener("click", () => {
      this._toggleOpen();
    });

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this._close();
      });
    }

    this.addEventListener("mobile-submenu:close", () => {
      window.trapFocus(this);
    });

    this.closeEsc = (e) => {
      if (
        e.key === "Escape" &&
        this.classList.contains("open") &&
        !this.querySelector(".mobile-menu__main-mega-menu.open")
      ) {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    this.handleResize = () => {
      if (!this._isMobile && this.classList.contains("open")) {
        this._forceClose();
      }

      this._setMaxHeightVariable();
    };

    window.addEventListener("resize", this.handleResize);

    this.handleMobileSearchOpen = () => {
      this._open(true);
    };

    document.addEventListener(
      "mobile-search:open",
      this.handleMobileSearchOpen,
    );
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener(
      "mobile-search:open",
      this.handleMobileSearchOpen,
    );
    window.removeEventListener("resize", this.handleResize);
  }

  _toggleOpen() {
    this.classList.contains("open") ? this._close() : this._open();
  }

  _forceClose() {
    this.classList.remove("open");
    this.toggle.setAttribute("aria-expanded", "false");
    window.closeDimmer(this);
    window.removeTrapFocus(this.toggle);
    window.unlockScroll(this);
    this.removeEventListener("transitionend", this.onEnd);
  }

  _open(focusSearch) {
    window.requestAnimationFrame(() => {
      this.classList.add("open");
      this.toggle.setAttribute("aria-expanded", "true");
      this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
      window.lockScroll(this);
      window.openDimmer(this);
      this.style.setProperty(
        "--mobile-menu-top",
        `${this.closest(".header").getBoundingClientRect().bottom}px`,
      );
      this._setMaxHeightVariable();

      if (focusSearch) {
        const searchInput = this.querySelector('input[name="q"]');
        searchInput?.click();
        searchInput?.focus();
      }
    });
    window.trapFocus(this);
  }

  _close() {
    this.classList.remove("open");
    this.toggle.setAttribute("aria-expanded", "false");
    this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    window.removeTrapFocus(this.toggle);

    const onEnd = (e) => {
      if (!("mobileMenuDrawer" in e.target.dataset)) return;

      this.removeEventListener("transitionend", onEnd);

      if (this.classList.contains("open")) return;
      window.unlockScroll(this);
      window.closeDimmer(this);
      this.dispatchEvent(
        new CustomEvent("mobile-menu:closed", { bubbles: true }),
      );
    };
    this.addEventListener("transitionend", onEnd);
  }

  _setMaxHeightVariable() {
    const container = this.querySelector(".header__mobile-menu-content");
    const { height } = container.getBoundingClientRect();
    this.style.setProperty("--mobile-menu-max-content-height", `${height}px`);
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("mobile-menu")) {
  customElements.define("mobile-menu", MobileMenu);
}
